import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import CancelSubscription from '~/pages/Payments/components/CancelSubscription';
import SuccessPayment from '~/pages/Payments/components/SuccessPayment';
import Payments from '~/pages/Payments/Payments';
import PPaymentCheckout from '~/pages/PaymentsCheckout/PaymentsCheckout';
import ProtectedRoute from '~/routes/ProtectedRoute';

const PAYMENTS_ROUTES: RouteObject[] = [
  {
    path: PATH.PAYMENTS.MAIN,
    element: (
      <ProtectedRoute>
        <Payments />
      </ProtectedRoute>
    ),
  },
  {
    path: PATH.PAYMENTS.CHECKOUT,
    element: (
      <ProtectedRoute>
        <PPaymentCheckout />
      </ProtectedRoute>
    ),
  },
  {
    path: PATH.PAYMENTS.SUCCESS,
    element: (
      <ProtectedRoute>
        <SuccessPayment />
      </ProtectedRoute>
    ),
  },
  {
    path: PATH.PAYMENTS.CANCEL_SUBSCRIPTION,
    element: (
      <ProtectedRoute>
        <CancelSubscription />
      </ProtectedRoute>
    ),
  },
];

export { PAYMENTS_ROUTES };
